import SvgWrapper from './SvgWrapper';
import { AllergnIconProps } from './types';

const LupinIcon = ({
  innerColor = '#fefefe',
  outerColor = '#f6d24e',
  ...props
}: AllergnIconProps) => {
  return (
    <SvgWrapper {...props}>
      <g
        id="Grupo_120"
        data-name="Grupo 120"
        transform="translate(-216.5 -2094)"
      >
        <g
          id="Rectángulo_19"
          data-name="Rectángulo 19"
          transform="translate(216.5 2094)"
          fill="#fff"
          stroke="#000"
          stroke-width="1"
        >
          <rect width="27" height="27" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="26" height="26" rx="1.5" fill="none" />
        </g>
        <g id="lupin" transform="translate(224.762 2099.747)">
          <path
            id="Trazado_9076"
            data-name="Trazado 9076"
            d="M92.528,8.68c.009-.027.017-.053.025-.08a3.3,3.3,0,0,0-.066-1.829,2.443,2.443,0,0,0-.563-.985A1.911,1.911,0,0,0,92,5.578a2.89,2.89,0,0,0-.057-1.6,1.723,1.723,0,0,0-1.095-1.231,1.274,1.274,0,0,0-.333-.048,3.577,3.577,0,0,0-.59-1.649,1.8,1.8,0,0,0-3.276,0,3.577,3.577,0,0,0-.59,1.649,1.275,1.275,0,0,0-.333.048,1.723,1.723,0,0,0-1.095,1.231,2.89,2.89,0,0,0-.057,1.6,1.9,1.9,0,0,0,.073.207,2.444,2.444,0,0,0-.563.985A3.3,3.3,0,0,0,84.014,8.6c.008.027.016.053.025.08a3.7,3.7,0,0,0-.879,3.466,2.506,2.506,0,0,0,2.4,1.816,2.517,2.517,0,0,0,1.608-.582,2.612,2.612,0,0,0,.658.208v1.92h.909v-1.92a2.612,2.612,0,0,0,.658-.208,2.5,2.5,0,0,0,4.01-1.233A3.7,3.7,0,0,0,92.528,8.68Zm-4.244,4.037a1.728,1.728,0,0,1-1.726-1.726c0-1.053.87-2.519,1.726-2.519s1.726,1.465,1.726,2.519a1.728,1.728,0,0,1-1.726,1.726Zm-3.41-4.425c-.176-.731.134-1.879.686-2.037a.942.942,0,0,1,.739.2,3.2,3.2,0,0,0-.252,1.181,2.237,2.237,0,0,0,.23.987A2.141,2.141,0,0,0,84.873,8.292Zm2.151-.235a1.329,1.329,0,0,1-.07-.424c0-.817.687-1.977,1.329-1.977s1.329,1.16,1.329,1.977a1.329,1.329,0,0,1-.07.424,1.855,1.855,0,0,0-2.518,0Zm2.329-3.323a1.07,1.07,0,0,1-.066.372,1.585,1.585,0,0,0-2.007,0,1.07,1.07,0,0,1-.066-.372,2.169,2.169,0,0,1,.37-1.1.73.73,0,0,1,1.4,0A2.17,2.17,0,0,1,89.353,4.734Zm.915,1.718a.942.942,0,0,1,.739-.2c.552.158.862,1.306.686,2.037a2.141,2.141,0,0,0-1.4.328,2.238,2.238,0,0,0,.23-.987A3.2,3.2,0,0,0,90.269,6.452Zm.8-2.2a2.009,2.009,0,0,1,.049,1.076l-.006.02a1.712,1.712,0,0,0-1.01.156,1.974,1.974,0,0,0,.156-.771,2.771,2.771,0,0,0-.2-.983.712.712,0,0,1,.533-.132A.9.9,0,0,1,91.073,4.252ZM88.283.909c.641,0,1.327,1.159,1.327,1.975,0,.021,0,.042,0,.063a1.551,1.551,0,0,0-2.651,0c0-.021,0-.042,0-.063C86.956,2.068,87.643.909,88.283.909Zm-2.79,3.344a.9.9,0,0,1,.479-.633.711.711,0,0,1,.533.132,2.771,2.771,0,0,0-.2.983,1.975,1.975,0,0,0,.156.771,1.712,1.712,0,0,0-1.01-.156l-.006-.02A2.009,2.009,0,0,1,85.494,4.252ZM86,12.99A1.594,1.594,0,0,1,84.034,11.9a3.081,3.081,0,0,1,.072-1.653,1.449,1.449,0,0,1,.817-1.034,1.308,1.308,0,0,1,1.059.3,3.889,3.889,0,0,0-.334,1.479,2.625,2.625,0,0,0,.742,1.831A1.6,1.6,0,0,1,86,12.99ZM92.533,11.9a1.594,1.594,0,0,1-2.357.926,2.625,2.625,0,0,0,.742-1.831,3.889,3.889,0,0,0-.334-1.479,1.307,1.307,0,0,1,1.059-.3C92.4,9.426,92.8,10.955,92.533,11.9Z"
            transform="translate(-83.046 0)"
          />
        </g>
      </g>
    </SvgWrapper>
  );
};

export default LupinIcon;
